import React from 'react';

export default function Loading() {
	return (
		<div className='overlay'>
			<i className='fas fa-spinner'></i>
		</div>
	);
}
